import React from 'react';
import styles from './error.module.scss';
import { useTranslation } from 'react-i18next';
import PrimaryButton from '../buttons/PrimaryButton';
import SecondaryButton from '../buttons/SecondaryButton';
import ErrorSupportLink from './ErrorSupportLink';
import FeatherIcon from "feather-icons-react";

interface IProps {
  code?: string
  chooseDifferentBank: () => void,
  finishConnection: () => void,
}

const ProviderUnavailableError: React.FC<IProps> = (props: IProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.screen} data-testid='error-container'>
      <div className={styles.topWrapper}>
          <FeatherIcon icon="alert-triangle" className={styles.icon} />
        <h1>{t<string>('Unable to connect to provider')}</h1>
        <div className={styles.content}>
          <p>{t<string>('Sorry, we are currently unable to connect to your provider.')}</p>
          <p>{t<string>('You may wish to choose another provider, or try selecting a different account type.')}</p>
          <p><>{t<string>('If the problem persists, please contact our')} <ErrorSupportLink errorCode={props.code} /></></p>
        </div>
      </div>
      <div className={styles.buttonWrapper}>
        <PrimaryButton onClick={props.chooseDifferentBank}>{t<string>('Return to Bank Select')}</PrimaryButton>
        <SecondaryButton onClick={props.finishConnection}>{t<string>('Quit')}</SecondaryButton>
      </div>
    </div>
  );
};

export default ProviderUnavailableError;
